import { gql, useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import * as React from 'react';

import { OrganizationDetailLayout } from '@/components/organizations/Detail';
import { Loading } from '@/imports/ui/chakra/components/Loading';
import { UnexpectedError } from '@/imports/ui/chakra/components/UnexpectedError';

import {
  OverviewDetail_GetOrganization,
  OverviewDetail_GetOrganizationVariables,
} from './graphql-types/OverviewDetail_GetOrganization';

import { Content } from './components/Content';

const GET_ORGANIZATION = gql`
  query OverviewDetail_GetOrganization($input: SingleOrganizationInput!) {
    organization(input: $input) {
      result {
        _id
        isSponsor
        ...OverviewContent_OrganizationFragment
      }
    }
  }
  ${Content.organizationFragment}
`;

export const OrganizationInformationPane: React.FC = () => {
  const router = useRouter();
  const { organizationId } = router.query;

  const { data: organizationData, loading } = useQuery<
    OverviewDetail_GetOrganization,
    OverviewDetail_GetOrganizationVariables
  >(GET_ORGANIZATION, {
    variables: {
      input: {
        id: organizationId.toString(),
      },
    },
  });

  return (
    <OrganizationDetailLayout>
      {loading ? (
        <Loading />
      ) : !organizationData?.organization?.result ||
        !organizationData.organization.result.isSponsor ? null : (
        <Content organization={organizationData?.organization?.result} />
      )}
    </OrganizationDetailLayout>
  );
};
